module.exports = __webpack_public_path__ + "img/10027.f8ef1768.png";